import * as RouteConstants from "./RouteConstants";
import * as AccessScopeConstants from "./AccessScopeConstants";
import * as SavedReportConstants from "./SavedReportConstants";
import Dashboard from "../components/features/dashboard";
import AdminUserList from "../components/features/adminUsers/list";
import AdminUserDetails from "../components/features/adminUsers/details";
import EnterpriseList from "../components/features/enterprises/list";
import EnterpriseAdd from "../components/features/enterprises/add";
import EnterpriseDetails from "../components/features/enterprises/details";
import UserList from "../components/features/users/list";
import AddUser from "../components/features/users/add";
import RoleList from "../components/features/roles/list";
import RoleDetails from "../components/features/roles/details";
import LearningObjectList from "../components/features/learningObjects/list";
import LearningObjectDetails from "../components/features/learningObjects/details";
import LearningMilestoneList from "../components/features/learningMilestones/list";
import LearningMilestoneDetails from "../components/features/learningMilestones/details";
import LearningPathwayList from "../components/features/learningPathways/list";
import LearningPathwayDetails from "../components/features/learningPathways/details";
import CustomFieldList from "../components/features/custom-fields/list";
import SelfEnterpriseDetails from "../components/features/enterprise";
import IntegrationsList from "../components/features/integrations";
import IntegrationDetails from "../components/features/integrations/details";
import MyDashboard from "../components/features/home/myDashboard";
import LearningJourney from "../components/features/home/learningJourney";
import AddCustomFieldSection from "../components/features/custom-fields/add";
import CustomSectionDetails from "../components/features/custom-fields/details";
import UserDetails from "../components/features/users/details";
import UserUploadHistory from "../components/features/users/uploads";
import LearningProgramJourney from "../components/features/learningProgramJourney";
import AudienceList from "../components/features/audiences/list";
import AudienceDetails from "../components/features/audiences/details";
import Report from "../components/features/reports";
import NotificationList from "../components/features/notifications/list";
import NotificationLogList from "../components/features/notifications/logs";
import NotificationForm from "../components/features/notifications/details";
import AssignmentList from "../components/features/assignments/list";
import CertificateList from "../components/features/certificates/list";
import CertificateDetails from "../components/features/certificates/add";
import RewardList from "../components/features/rewards/list";
import RewardDetails from "../components/features/rewards/details";
import MyTeamReports from "../components/features/myTeamReports";
import SavedReportList from "../components/features/savedReports";
import CertificateBatchList from "../components/features/certificateBatches";
import AuditLogList from "../components/features/auditLogs";
import Profile from "../components/features/profile";
import AccountPreferences from "../components/features/accountPreferences";
import LearnerRewards from "../components/features/learnerRewards";
import LearningProgramMilestoneObjDetails from "../components/features/learningProgramJourney/milestoneDetails";
import CustomNotificationForm from "../components/features/notifications/details/CustomNotificationForm";

export const LIST = "LIST";
export const ADD = "ADD";
export const EDIT = "EDIT";

export const APP_READ_PERMISSION = "Read";
export const APP_CREATE_PERMISSION = "Create";
export const APP_DELETE_PERMISSION = "Delete";
export const APP_UPDATE_PERMISSION = "Update";

export const DASHBOARD = "DASHBOARD";
export const USERS = "USERS";
export const ENTERPRISES = "ENTERPRISES";
export const ADMINISTRATION = "ADMINISTRATION";
export const LEARNING_CONTENT = "LEARNING_CONTENT";
export const ENTERPRISE = "ENTERPRISE";
export const INTEGRATIONS = "INTEGRATIONS";
export const LEARNING_DASHBORD = "LEARNING_DASHBORD";
export const ROLES = "ROLES";
export const LEARNING_OBJECTS = "LEARNING_OBJECTS";
export const LEARNING_PATHS = "LEARNING_PATHS";
export const LEARNING_MILESTONES = "LEARNING_MILESTONES";
export const CUSTOM_FIELDS = "CUSTOM_FIELDS";
export const AUDIENCES = "AUDIENCES";
export const LEARNING_JOURNEY = "LEARNING_JOURNEY";
export const REPORTS = "REPORTS";
export const NOTIFICATIONS = "NOTIFICATIONS";
export const WORKFLOWS = "WORKFLOWS";
export const ASSIGNMENTS = "ASSIGNMENTS";
export const CERTIFICATES = "CERTIFICATES";
export const REWARDS = "REWARDS";
export const LEARNER_REWARDS = "LEARNER_REWARDS";
export const MYTEAM = "MYTEAM";
export const PROFILE = "PROFILE";
export const ACCOUNT_PREFERENCES = "ACCOUNT_PREFERENCES";
export const NOTIFICATION_LIST = "NOTIFICATION_LIST";
export const NOTIFICATION_LOGS = "NOTIFICATION_LOGS";
export const USER_UPLOADS = "USER_UPLOADS";
export const REPORT_VIEWS = "REPORT_VIEWS";
export const SAVED_REPORTS = "SAVED_REPORTS";
export const MY_TEAM_REPORTS = "MY_TEAM_REPORTS";
export const MY_TEAM_SAVED_REPORTS = "MY_TEAM_SAVED_REPORTS";
export const CERTIFICATE_DOWNLOADS = "CERTIFICATE_DOWNLOADS";
export const AUDIT_LOGS = "AUDIT_LOGS";

export const PROFILE_MENU = {
  id: PROFILE,
  label: "profile",
  to: RouteConstants.APP_ROUTE_PROFILE,
  Component: Profile,
};

export const ACCOUNT_PREFERENCES_MENU = {
  id: ACCOUNT_PREFERENCES,
  label: "account_preferences",
  to: RouteConstants.APP_ROUTE_PREFERENCES,
  Component: AccountPreferences,
};

export const LEARNER_DASHBOARD_TYPES = [
  {
    id: DASHBOARD,
    value: DASHBOARD,
    name: "Dashboard",
    i18n: true,
  },
  {
    id: LEARNING_JOURNEY,
    value: LEARNING_JOURNEY,
    name: "Learning Journey",
    i18n: true,
  },
];

export const LEARNER_MENU_ITEMS = [
  {
    id: DASHBOARD,
    to: RouteConstants.APP_ROUTE_LEARNING_DASHBOARD,
    index: true,
    label: "dashboard",
    icon: "pi pi-fw pi-home",
    Component: MyDashboard,
  },
  {
    id: LEARNING_JOURNEY,
    to: RouteConstants.APP_ROUTE_LEARNING_JOURNEY,
    label: "learning_journey",
    icon: "pi pi-fw pi-graduation-cap",
    childrens: [
      {
        id: LEARNING_JOURNEY,
        label: "learning_journey",
        index: true,
        to: RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS,
        Component: LearningJourney,
      },
      {
        id: EDIT,
        label: "edit_learning_journey",
        to: RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONES,
        Component: LearningProgramJourney,
      },
      {
        id: EDIT,
        label: "view_learning_journey_milestone",
        to: RouteConstants.APP_ROUTE_LEARNING_JOURNEY_PROGRAMS_MILESTONE_DETAILS,
        Component: LearningProgramMilestoneObjDetails,
      },
    ],
  },
  {
    id: MYTEAM,
    to: RouteConstants.APP_ROUTE_MY_TEAM,
    label: "my_team",
    icon: "pi pi-fw pi-users",
    conditions: {
      isManager: true,
    },
    childrens: [
      {
        id: MY_TEAM_REPORTS,
        label: "reports",
        to: RouteConstants.APP_ROUTE_MY_TEAM_REPORTS,
        index: true,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_MY_TEAM_REPORTS_LIST,
            Component: MyTeamReports,
            index: true,
          },
        ],
      },
      {
        id: MY_TEAM_SAVED_REPORTS,
        label: "saved_reports",
        to: RouteConstants.APP_ROUTE_MY_TEAM_SAVED_REPORTS,
        // Report download links (Send history, emails) belong here.
        activePaths: [RouteConstants.APP_ROUTE_REPORT_DOWNLOADS],
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_MY_TEAM_SAVED_REPORTS_LIST,
            Component: SavedReportList,
            index: true,
            additionalProps: {
              kind: SavedReportConstants.SAVED_REPORT_KIND_MY_TEAM,
            },
          },
        ],
      },
    ],
  },
  {
    id: LEARNER_REWARDS,
    to: RouteConstants.APP_ROUTE_REWARDS,
    label: "my_rewards",
    icon: "pi pi-fw pi-gift",
    Component: LearnerRewards,
  },
];

export const ENTERPRISE_ADMIN_MENU_ITEMS = [
  {
    id: ADMINISTRATION,
    label: "administration",
    icon: "pi pi-fw pi-wrench",
    to: RouteConstants.APP_ROUTE_ADMINISTRATION,
    scope: [AccessScopeConstants.UserAccess],
    index: true,
    childrens: [
      {
        id: USERS,
        label: "users",
        icon: "pi pi-fw pi-users",
        index: true,
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_USERS,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_USERS_LIST,
            Component: UserList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
          {
            id: ADD,
            label: "add_user",
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_USERS_ADD,
            Component: AddUser,
            permission: APP_CREATE_PERMISSION,
          },
          {
            id: EDIT,
            label: "edit_user",
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_USERS_EDIT,
            Component: UserDetails,
            permission: APP_READ_PERMISSION,
          },
          {
            id: USER_UPLOADS,
            label: "user_upload_history",
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_USER_UPLOADS,
            Component: UserUploadHistory,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
      {
        id: ROLES,
        label: "roles",
        icon: "pi pi-fw pi-users",
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_ROLES,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_ROLES_LIST,
            Component: RoleList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
          {
            id: ADD,
            label: "add_role",
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_ROLES_ADD,
            Component: RoleDetails,
            permission: APP_CREATE_PERMISSION,
          },
          {
            id: EDIT,
            label: "edit_role",
            to: RouteConstants.APP_ROUTE_ADMINISTRATION_ROLES_EDIT,
            Component: RoleDetails,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
    ],
  },
  {
    id: CUSTOM_FIELDS,
    label: "custom_fields",
    icon: "pi pi-fw pi-id-card",
    scope: [AccessScopeConstants.UserAccess],
    to: RouteConstants.APP_ROUTE_ADMINISTRATION_CUSTOM_FIELDS,
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_CUSTOM_FIELDS_LIST,
        Component: CustomFieldList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        label: "add_custom_field_section",
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS_ADD,
        Component: AddCustomFieldSection,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_custom_field_section",
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_CUSTOM_FIELD_SECTIONS_EDIT,
        Component: CustomSectionDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
  {
    id: AUDIENCES,
    label: "audiences",
    icon: "pi pi-fw pi-users",
    scope: [AccessScopeConstants.UserAccess],
    to: RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES,
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_LIST,
        Component: AudienceList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        label: "add_audience",
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_ADD,
        Component: AudienceDetails,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_audience",
        to: RouteConstants.APP_ROUTE_ADMINISTRATION_AUDIENCES_EDIT,
        Component: AudienceDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
  {
    id: LEARNING_CONTENT,
    label: "learning_content",
    icon: "pi pi-fw pi-graduation-cap",
    to: RouteConstants.APP_ROUTE_CONTENTS,
    scope: [AccessScopeConstants.ContentAccess],
    childrens: [
      {
        id: LEARNING_OBJECTS,
        label: "learning_objects",
        icon: "pi pi-fw pi-users",
        to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_OBJECTS,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_OBJECTS_LIST,
            Component: LearningObjectList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
          {
            id: ADD,
            label: "add_learning_object",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_OBJECTS_ADD,
            Component: LearningObjectDetails,
            permission: APP_CREATE_PERMISSION,
          },
          {
            id: EDIT,
            label: "edit_learning_object",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_OBJECTS_EDIT,
            Component: LearningObjectDetails,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
      {
        id: LEARNING_MILESTONES,
        label: "learning_milestones",
        to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_MILESTONES,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_MILESTONES_LIST,
            Component: LearningMilestoneList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
          {
            id: ADD,
            label: "add_learning_milestone",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_MILESTONES_ADD,
            Component: LearningMilestoneDetails,
            permission: APP_CREATE_PERMISSION,
          },
          {
            id: EDIT,
            label: "edit_learning_milestone",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_MILESTONES_EDIT,
            Component: LearningMilestoneDetails,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
      {
        id: LEARNING_PATHS,
        label: "learning_programs",
        to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_PATHS,
        index: true,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_PATHS_LIST,
            Component: LearningPathwayList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
          {
            id: ADD,
            label: "add_learning_programs",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_PATHS_ADD,
            Component: LearningPathwayDetails,
            permission: APP_CREATE_PERMISSION,
          },
          {
            id: EDIT,
            label: "edit_learning_programs",
            to: RouteConstants.APP_ROUTE_CONTENTS_LEARNING_PATHS_EDIT,
            Component: LearningPathwayDetails,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
    ],
  },
  {
    id: ASSIGNMENTS,
    label: "assignments",
    icon: "pi pi-fw pi-hourglass",
    to: RouteConstants.APP_ROUTE_ASSIGNMENTS,
    scope: [
      AccessScopeConstants.UserAccess,
      AccessScopeConstants.ContentAccess,
    ],
    permission: APP_READ_PERMISSION,
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_ASSIGNMENTS_LIST,
        Component: AssignmentList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_learning_programs",
        to: RouteConstants.APP_ROUTE_ASSIGNMENTS_LEARNING_PATHS,
        Component: LearningPathwayDetails,
        permission: APP_READ_PERMISSION,
        additionalProps: { isFromAssigment: true },
      },
      {
        id: EDIT,
        label: "edit_audience",
        to: RouteConstants.APP_ROUTE_ASSIGNMENTS_AUDIENCE,
        Component: AudienceDetails,
        permission: APP_READ_PERMISSION,
        additionalProps: { isFromAssigment: true },
      },
    ],
  },
  {
    id: CERTIFICATES,
    label: "certificates",
    icon: "pi pi-fw pi-crown",
    scope: [AccessScopeConstants.ContentAccess],
    to: RouteConstants.APP_ROUTE_CERTIFICATES,
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_CERTIFICATES_LIST,
        Component: CertificateList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        to: RouteConstants.APP_ROUTE_CERTIFICATES_ADD,
        Component: CertificateDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
  {
    id: REWARDS,
    label: "rewards",
    icon: "pi pi-fw pi-star",
    scope: [AccessScopeConstants.ContentAccess],
    to: RouteConstants.APP_ROUTE_REWARDS,
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_REWARDS_LIST,
        Component: RewardList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        to: RouteConstants.APP_ROUTE_REWARDS_ADD,
        Component: RewardDetails,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        to: RouteConstants.APP_ROUTE_REWARDS_EDIT,
        Component: RewardDetails,
        permission: APP_UPDATE_PERMISSION,
      },
    ],
  },
  // {
  //   id: NOTIFICATIONS,
  //   label: "notifications",
  //   icon: "pi pi-fw pi-envelope",
  //   to: RouteConstants.APP_ROUTE_NOTIFICATIONS,
  //   scope: [AccessScopeConstants.EnterpriseAccess],
  //   permission: APP_READ_PERMISSION,
  //   childrens: [
  //     {
  //       id: LIST,
  //       to: RouteConstants.APP_ROUTE_NOTIFICATIONS_LIST,
  //       Component: NotificationList,
  //       index: true,
  //       permission: APP_READ_PERMISSION,
  //     },
  //     {
  //       id: ADD,
  //       to: RouteConstants.APP_ROUTE_NOTIFICATIONS_ADD,
  //       Component: NotificationForm,
  //       index: true,
  //       permission: APP_READ_PERMISSION,
  //     }
  //   ],
  // },
  {
  id: NOTIFICATIONS,
  label: "notifications",
  icon: "pi pi-fw pi-envelope",
  to: RouteConstants.APP_ROUTE_NOTIFICATIONS,
  scope: [AccessScopeConstants.EnterpriseAccess],
  childrens: [
    {
      id: NOTIFICATION_LIST,
      label: "notification_buildertab",
      icon: "pi pi-fw pi-list",
      to: RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER,
      childrens: [
        {
          id: LIST,
          to: RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_LIST,
          Component: NotificationList,
          index: true,
          permission: APP_READ_PERMISSION,
        },
        {
          id: ADD,
          label: "add_notification",
          to: RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_ADD,
          Component: NotificationForm,
          permission: APP_CREATE_PERMISSION,
        },
        {
          id: EDIT,
          label: "custom_edit_notification",
          to: RouteConstants.APP_ROUTE_NOTIFICATIONS_BUILDER_CUSTOM_EDIT,
          Component: CustomNotificationForm,
          permission: APP_UPDATE_PERMISSION
        }
      ],
    },
    {
      id: NOTIFICATION_LOGS,
      label: "notification_audit",
      icon: "pi pi-fw pi-clock",
      to: RouteConstants.APP_ROUTE_NOTIFICATIONS_LOGS,
      childrens: [
        {
          id: LIST,
          to: RouteConstants.APP_ROUTE_NOTIFICATIONS_LOGS_LIST,
          Component: NotificationLogList, // <-- your new component
          index: true,
          permission: APP_READ_PERMISSION,
        },
      ],
    },
  ],
},
  {
    id: REPORTS,
    label: "reports",
    icon: "pi pi-fw pi-wave-pulse",
    to: RouteConstants.APP_ROUTE_REPORTS,
    // Reports, Saved reports and Certificate downloads all check
    // ReportAccess on the API (ReportController, CertificateBatchController),
    // not EnterpriseAccess (C-BUG-2, R6).
    scope: [AccessScopeConstants.ReportAccess],
    permission: APP_READ_PERMISSION,
    childrens: [
      {
        id: REPORT_VIEWS,
        label: "reports",
        icon: "pi pi-fw pi-chart-bar",
        to: RouteConstants.APP_ROUTE_REPORTS_VIEW,
        index: true,
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_REPORTS_LIST,
            Component: Report,
            index: true,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
      {
        id: SAVED_REPORTS,
        label: "saved_reports",
        icon: "pi pi-fw pi-bookmark",
        to: RouteConstants.APP_ROUTE_SAVED_REPORTS,
        // Report download links (Send history, emails) belong here.
        activePaths: [RouteConstants.APP_ROUTE_REPORT_DOWNLOADS],
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_SAVED_REPORTS_LIST,
            Component: SavedReportList,
            index: true,
            permission: APP_READ_PERMISSION,
            additionalProps: {
              kind: SavedReportConstants.SAVED_REPORT_KIND_ADMIN,
            },
          },
        ],
      },
      {
        id: CERTIFICATE_DOWNLOADS,
        label: "certificate_batch_downloads",
        icon: "pi pi-fw pi-verified",
        to: RouteConstants.APP_ROUTE_CERTIFICATE_DOWNLOADS,
        // "Certificates ready" email links belong here.
        activePaths: [RouteConstants.APP_ROUTE_CERTIFICATE_BATCH_DOWNLOADS],
        childrens: [
          {
            id: LIST,
            to: RouteConstants.APP_ROUTE_CERTIFICATE_DOWNLOADS_LIST,
            Component: CertificateBatchList,
            index: true,
            permission: APP_READ_PERMISSION,
          },
        ],
      },
    ],
  },
  {
    id: INTEGRATIONS,
    label: "integrations",
    icon: "pi pi-fw pi-link",
    to: RouteConstants.APP_ROUTE_INTEGRATIONS,
    scope: [AccessScopeConstants.EnterpriseAccess],
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_INTEGRATIONS_LIST,
        Component: IntegrationsList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        label: "add_integration",
        to: RouteConstants.APP_ROUTE_INTEGRATIONS_ADD,
        Component: IntegrationDetails,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_integration",
        to: RouteConstants.APP_ROUTE_INTEGRATIONS_EDIT,
        Component: IntegrationDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
  {
    id: ENTERPRISE,
    label: "enterprise_management",
    icon: "pi pi-fw pi-building",
    to: RouteConstants.APP_ROUTE_ENTERPRISE,
    scope: [AccessScopeConstants.EnterpriseAccess],
    permission: APP_READ_PERMISSION,
    Component: SelfEnterpriseDetails,
  },
  {
    id: AUDIT_LOGS,
    label: "audit_logs",
    icon: "pi pi-fw pi-history",
    to: RouteConstants.APP_ROUTE_AUDIT_LOGS,
    scope: [AccessScopeConstants.EnterpriseAccess],
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_AUDIT_LOGS_LIST,
        Component: AuditLogList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
];

export const ADMIN_MENU_ITEMS = [
  {
    id: DASHBOARD,
    label: "dashboard",
    icon: "pi pi-fw pi-home",
    to: RouteConstants.APP_ROUTE_DASHBOARD,
    Component: Dashboard,
    index: true,
  },
  {
    id: USERS,
    label: "users",
    icon: "pi pi-fw pi-users",
    to: RouteConstants.APP_ROUTE_USERS,
    scope: [AccessScopeConstants.UserAccess],
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_USERS_LIST,
        Component: AdminUserList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        label: "add_user",
        to: RouteConstants.APP_ROUTE_USERS_ADD,
        Component: AdminUserDetails,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_user",
        to: RouteConstants.APP_ROUTE_USERS_EDIT,
        Component: AdminUserDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
  {
    id: ENTERPRISES,
    label: "enterprises",
    icon: "pi pi-fw pi-building",
    to: RouteConstants.APP_ROUTE_ENTERPRISES,
    scope: [
      AccessScopeConstants.TenantAccess,
      AccessScopeConstants.LicenseAccess,
    ],
    childrens: [
      {
        id: LIST,
        to: RouteConstants.APP_ROUTE_ENTERPRISES_LIST,
        Component: EnterpriseList,
        index: true,
        permission: APP_READ_PERMISSION,
      },
      {
        id: ADD,
        label: "add_enterprise",
        to: RouteConstants.APP_ROUTE_ENTERPRISES_ADD,
        Component: EnterpriseAdd,
        permission: APP_CREATE_PERMISSION,
      },
      {
        id: EDIT,
        label: "edit_enterprise",
        to: RouteConstants.APP_ROUTE_ENTERPRISES_EDIT,
        Component: EnterpriseDetails,
        permission: APP_READ_PERMISSION,
      },
    ],
  },
];
